import styled from 'styled-components'

import { mediaMax } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import { LocationDot } from '../CurrentLocationMarker'

const Anchor = styled.div`
  position: relative;
  width: 0;
  height: 0;
`

const Dot = styled(LocationDot)`
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
`

const Label = styled.span`
  position: absolute;
  bottom: 20px;
  left: 0;
  transform: translateX(-50%);

  padding: 4px 10px;
  border-radius: var(--ds-radius-md);

  background-color: var(--ds-bg-container-default);
  box-shadow: var(--ds-elevation-1);

  ${typeStyle('-ds-font-body-sm-regular')}
  color: var(--ds-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMax.md`
    max-width: 50vw;
  `}
`

const Caret = styled.span`
  position: absolute;
  bottom: 15px;
  left: -5px;

  border-top: 5px solid var(--ds-bg-container-default);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
`

type PlaceMarkerProps = {
  /* Consumed by google-map-react to position the marker */
  // eslint-disable-next-line react/no-unused-prop-types
  lat: number
  // eslint-disable-next-line react/no-unused-prop-types
  lng: number
  name: string
  labelVisible: boolean
  onShowLabel: () => any
}

const PlaceMarker = ({ name, labelVisible, onShowLabel }: PlaceMarkerProps) => (
  <Anchor>
    <Dot
      as="button"
      type="button"
      $brand
      aria-label={name}
      aria-expanded={labelVisible}
      onClick={onShowLabel}
    />
    {labelVisible && (
      <>
        <Caret aria-hidden />
        <Label title={name}>{name}</Label>
      </>
    )}
  </Anchor>
)

export default PlaceMarker
